import * as React from 'react'

import { PermissionGroupDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

const PermissionsRootPage = React.lazy(
  () => import('modules/permissions/pages/settings/PermissionsRootPage')
)

const PermissionsIndexRootPage = React.lazy(
  () => import('modules/permissions/pages/settings/PermissionsIndexRootPage')
)

const PermissionsShowRootPage = React.lazy(
  () => import('modules/permissions/pages/settings/PermissionsShowRootPage')
)

const ChangeGroupPageModalPage = React.lazy(
  () => import('modules/permissions/pages/settings/ChangeGroupPageModalPage')
)

const DelegatePermissionGroupPage = React.lazy(
  () => import('modules/permissions/pages/settings/DelegatePermissionGroupPage')
)

const EmployeesPage = React.lazy(() => import('modules/permissions/pages/settings/EmployeesPage'))

const ExternalsChangeGroupPageModalPage = React.lazy(
  () => import('modules/permissions/pages/settings/ExternalsChangeGroupPageModalPage')
)

const ExternalsPage = React.lazy(() => import('modules/permissions/pages/settings/ExternalsPage'))

const PermissionGroupPage = React.lazy(
  () => import('modules/permissions/pages/settings/PermissionGroupPage')
)

const VisibilityPage = React.lazy(() => import('modules/permissions/pages/settings/VisibilityPage'))

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.permissions.path,
      element: <PermissionsRootPage />,
      handle: {
        meta: () => {
          return getSettingPageMeta(navigation, 'permissions')
        },
      },
      children: [
        {
          index: true,
          element: <PermissionsIndexRootPage />,
        },
        {
          path: navigation.settings.permissions.id.path,
          element: <PermissionsShowRootPage />,
          children: [
            {
              index: true,
              element: <PermissionGroupPage />,
              handle: {
                meta: ({ params, watchQuery }) => {
                  return watchQuery({
                    query: PermissionGroupDocument,
                    variables: {
                      id: Number(params['id']),
                    },
                  }).map((result) => {
                    return {
                      title: `${result?.data?.permissions.permissionGroup?.name}`,
                      description: i18n.t('company_settings.general.permissions.description'),
                    }
                  })
                },
              },
            },
            {
              path: navigation.settings.permissions.id.delegate.path,
              element: <DelegatePermissionGroupPage />,
              handle: {
                meta: ({ params, watchQuery }) => {
                  return watchQuery({
                    query: PermissionGroupDocument,
                    variables: {
                      id: Number(params['id']),
                    },
                  }).map((result) => {
                    return {
                      title: `${result?.data?.permissions.permissionGroup?.name}`,
                      description: i18n.t('company_settings.general.permissions.description'),
                    }
                  })
                },
              },
            },
            {
              path: navigation.settings.permissions.id.visibility.path,
              element: <VisibilityPage />,
              handle: {
                meta: ({ params, watchQuery }) => {
                  return watchQuery({
                    query: PermissionGroupDocument,
                    variables: {
                      id: Number(params['id']),
                    },
                  }).map((result) => {
                    return {
                      title: `${result?.data?.permissions.permissionGroup?.name}`,
                      description: i18n.t('company_settings.general.permissions.description'),
                    }
                  })
                },
              },
            },
            {
              path: navigation.settings.permissions.id.employees.path,
              element: <EmployeesPage />,
              handle: {
                meta: ({ params, watchQuery }) => {
                  return watchQuery({
                    query: PermissionGroupDocument,
                    variables: {
                      id: Number(params['id']),
                    },
                  }).map((result) => {
                    return {
                      title: `${result?.data?.permissions.permissionGroup?.name}`,
                      description: i18n.t('company_settings.general.permissions.description'),
                    }
                  })
                },
              },
              children: [
                {
                  path: navigation.settings.permissions.id.employees.userIdAssign.path,
                  element: <ChangeGroupPageModalPage />,
                },
              ],
            },
            {
              path: navigation.settings.permissions.id.externals.path,
              element: <ExternalsPage />,
              handle: {
                meta: ({ params, watchQuery }) => {
                  return watchQuery({
                    query: PermissionGroupDocument,
                    variables: {
                      id: Number(params['id']),
                    },
                  }).map((result) => {
                    return {
                      title: `${result?.data?.permissions.permissionGroup?.name}`,
                      description: i18n.t('company_settings.general.permissions.description'),
                    }
                  })
                },
              },
              children: [
                {
                  path: navigation.settings.permissions.id.externals.userIdAssign.path,
                  element: <ExternalsChangeGroupPageModalPage />,
                },
              ],
            },
          ],
        },
      ],
    },
  ]
}

export default settingsRoutes
